<template>
  <div id="app">
      <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="leftfloat">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">{{YearIssue_No}}</div>
                
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml">
                    <IssueArticleListControl :newListTitle="newListTitle" :List="newList" :isOA='false' :ischeckbox='true' iscount="true" :count="count" :type="0" :isycb="false" :isdatab="true" :isdataa="false" :isgzh="true"></IssueArticleListControl>
                </div>
                  
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import IssueArticleListControl from "../components/IssueArticleListControl/IssueArticleListControl";
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {
      keywords: "",
      activeName: "first",
      data: {},
      newList: [],
      List: [],
      Lista: [],
      newListTitle: "",
      cotype: "",
      FileGUID: "",
      count: 0,
      titles:"",
      isyuchuban: false,
      YearIssue_No:'',
      id:0,
      type:"",
      paramas: {
        PageSize: 100,
        PageIndex: 0,
        IssueId: 0
      }
    };
  },
  components: {
    IssueArticleListControl,
    HomeHeader
  },
  created() {
    this.id=this.$route.query.IssueId
    this.type=this.$route.query.type
      this._getListb()
  },
  watch: {
    '$route' (to, from) { 
       if (to.query.IssueId !== from.query.IssueId) {
        this.type = to.query.type
         this.id = to.query.IssueId
        this._getListb()
      }
      
    }
  },
  methods: {

    _getListb(pageSize,PageIndex,) {
      var time = new Date().getTime();
      this.paramsa = {
        PageSize: pageSize,
        PageIndex:PageIndex,
        Type: this.type,
        Key: this.id,
        src: time
      };
      this.$store
        .dispatch("_getListb",this.paramsa)
        .then(res => {
          if (res.data.IsSuccess) {
            this.newList = res.data.Data;
            this.count = res.data.ItemCount;
            this.YearIssue_No=res.data.Title
            this.titles=res.data.Title
            document.title=res.data.Title
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },

  }
};
</script>

<style scoped>
</style>
